import type { Coluna } from './Tabela';

/**
 * O total da coluna sobre a LISTA INTEIRA, e não só a página visível. Com a
 * paginação (p.26), a linha de soma passou a somar só a página — e o volume
 * dos tanques mudava ao virar a página. Quem pagina e soma usa isto.
 */
export function totalSobreTudo<T>(colunas: readonly Coluna<T>[], todas: readonly T[]): readonly Coluna<T>[] {
  return colunas.map((coluna) => {
    const total = coluna.total;
    return total ? { ...coluna, total: () => total(todas) } : coluna;
  });
}
